/**@description OrphansiteId, pagination value, approved method constants */
export const Constants = {
    orphanSiteId: '38af7118-aa2a-4d9d-8128-cdbcddeb6180',
    password: /(?=.{8,})((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$}+\]\-/{)>,;:'`~".<(|$=[^$?$%$%^&*])|(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$}+\]\-/{)>,;:'`~".<(|$=[^$?$%$%^&*])).*/,
    emailRegex: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    domainRegex: /^@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    phoneRegex: /^[+]?\d+$/,
    specialCharacterRegex: /[!@#$}+\]\-/{)>,;:'`~".<(|$=[^$?$%$%^&*]/,
    numberRegex: /[0-9]/,
    upperCaseRegex: /[A-Z]/,
    lowerCaseRegex: /[a-z]/,
    pagination: [25, 50, 75, 100],
    registerCustomer: {
        infoP1:
            'Use this form to register a new Customer to which Sites may be assigned. Each Site assigned to a Customer can be configured with unique contact information, or the Customer contact information may be inherited by the Site',
        infoP2:
            'Enter an appropriate Customer name and provide default contact information and default details regarding the approved contact method for Sites created for the new Customer. Details entered in the Approved Contact Method notes will be used to direct the delivery of Factory-Assisted Device Reset RESPONSE codes to the intended recipient',
        infoP3:
            'Once all information has been entered, click Submit to create the new site. Click Reset to reset all fields on the form.',
    },
    registerCustomerSite: {
        infoP1:
            'Use this form to register a new Site for the selected Customer, to which devices can be assigned. All devices assigned to a Customer Site share common contact information and an approved contact method for delivering Factory-Assisted Device Reset RESPONSE codes.',
        infoP2:
            'Select the appropriate Customer from the drop-down menu,if the Customer does not exist, click New to register a new Customer. After selecting the appropriate Customer, enter a name for the new Site. Provide contact information and details regarding the approved contact method for the new Site, check the Use Default checkbox for fields which should inherit values from the associated Customer record.',
        infoP3:
            'Once all information has been entered, click Submit to create the new site. Click Reset to reset all fields on the form.',
    },
    AutoApproval: {
        infoP1:
            'Use this form to accept automaticly, all product access base one the email domaine name.'
    },
    findDeviceKey: {
        infoP1:
            'Use this form to recall a list of all devices shipped to a customer under a specific Registration Key. The Registration Key is provided to the customer in a communication separate from the material delivery for the associated order.',
        infoP2:
            'Enter the Registration Key provided by the customer/end-user and click Submit. To clear the Registration Key field, click Reset.',
    },
    assignSite: {
        infoP1: 'The devices associated with the entered Registration Key are displayed below.',
        infoP2:
            "To Assign one or more devices to a specific Customer and Site, choose the correct Customer from the Customer drop-down menu. After selecting a Customer, the associated Sites will be displayed in the Site drop-down menu, choose the correct Site from the Site drop-down menu. If the required Customer or Site entries are not listed, select 'New...' from the appropriate drop-down menu to register a new Customer or Site before assigning devices.",
        infoP3:
            'With the appropriate Customer and Site selected, select one or more devices by clicking on the checkboxes, and click Assign.(Use checkbox in the header to select all the entries from the list to be assigned together.)',
    },
    findDeviceNo: {
        infoP1:
            'Use this form to look up a registered Device by Device Type and Serial Number to check the status of the device or to initiate a Factory-Assisted Device Reset.',
        infoP2:
            'Select the appropriate device type from the drop-down menu and enter the Serial Number. Click Submit when finished. Click Reset to reset all fields on the form.',
    },
    deviceReset: {
        infoP1:
            'Use this form to initiate and complete Factory-Assisted Device Reset requests for a device of a specific type and serial number.',
        infoP2:
            'Requests may only be initiated for devices which have been properly assigned to a Customer and Site and for which a FADR public key is available. Support personnel are encouraged to take reasonable steps to confirm that the initiator of a request is a valid representative of the subject Company(history of prior contact, inspection of email domain, etc.). Requests may be initiated by any available means of contact between the customer and support personnel.',
        infoP3:
            'To initiate a FADR request, click the Generate button next to the INITIATE code field. The generated code (INIT xxx-xxx-xxx-xxx) can be delivered back to the initiator of the request by any available means. The customer can use the provided INITIATE code to generate a REQUEST code on the subject device. To discard a generated INITIATE code, click Discard.',
        infoP4:
            'To complete a pending FADR request, a valid REQUEST code must be received from the customer before the INITIATE code has expired. The REQUEST code may be communicated by any available means of contact. Enter the customer-provided REQUEST code in the Request Code field (REQ xxxxxxxx xxx-xxx-xxx-xxx xxx-xxx-xxx-xxx). Click Generate Response Code to generate the RESPONSE code to be sent to the customer. Click Reset to reset the Request Code field.',
        infoP5:
            'Once a RESPONSE code has been generated, it must only be delivered to the customer contact listed on this page, using the contact method indicated (telephone, email, other), following any special instructions in the Approved Contact Method notes field entered at time of device registration. The RESPONSE code must NOT be sent back to the request initiator if the initiator’s contact information does not match the contact information listed on this page.',
        infoManufacturing:
            'Manufacturing information for the chosen device is provided for cross-referencing only. The customer does not need to provide this information to initiate a request.',
    },
    addPublicKey: {
        infoP1:
            'Use this form to load a new FADR public key (raw key) or default TLS certificate (Base-64 encoded PEM) into the data store for the identified device. Check the Update box for one or both items to be updated. Click Submit to overwrite the selected field(s) for the identified device. Click Reset to reset all fields on the form.',
    },
    modifySite: {
        infoP1:
            'Use this form to re-assign a registered device to a different site, the new site may be under the same Customer record or a different Customer record.',
        infoP2:
            'Enter the name of the Customer to which the new site is attached and click Submit. The list of available sites will be displayed below. Find the appropriate site to which the device should be transferred in the list and click Assign.',
    },
    listDevices: {
        infoP1:
            'All devices with pending INITIATE codes and unexpired RESPONSE codes are shown below. Choose a device and click “Select” to see additional information.',
    },
    approvedContactMethod: [
        {
            methodName: 'E-mail',
        },
        {
            methodName: 'Telephone',
        },
        {
            methodName: 'Other',
        },
    ],
    noInternetLabel: 'No Internet Connection',
    deviceTypeList: [
        {
            name: 'SMP',
        },
        {
            name: 'Form7',
        },
    ],
    deviceRegistration: {
        infoP1:
            'Use this form to register new devices to the factory reset system. User needs to input the required json object body with all the device information as provided in the example.',
    },
    DTPGConfigurationTool: 'DTPGUser',
    currentUser: 'currentUser',
    englishLanguage: 'en',
    frenchLanguage: 'fr',
    englishMessageForInvalidCode: 'Invalid code. Please check your code and try again.',
    frenchMessageForInvalidCode: 'Code invalide. Veuillez vérifier votre code et réessayer.',
    englishMessageForRgisterationComplete: 'Registeration Completed.',
    frenchMessageForRegistrationComplete: 'Inscription terminée.'
};
